import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';
export class ClotureCompteRenduPreliminaireEvent extends UserEvent {
  public static NAME = 'CLOTURE_COMPTE_RENDU_PRELIMINAIRE_EVENT';

  constructor(
    public idCreneau: string,
    public fin: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(ClotureCompteRenduPreliminaireEvent.NAME, fin, coordinates);
  }

  public static hydrate(obj: ClotureCompteRenduPreliminaireEvent): ClotureCompteRenduPreliminaireEvent {
    return new ClotureCompteRenduPreliminaireEvent(obj.idCreneau, dayjs(obj.fin), obj.coordinates);
  }
}
